"use client";

import { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
gsap.registerPlugin(useGSAP);
export default function Casestudyhero() {
  const container = useRef<HTMLDivElement>(null);
  useGSAP(() => {
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".pd-eyebrow", {
        y: 16
      });
      gsap.set(".pd-heading", {
        y: 24
      });
      gsap.set(".pd-sub", {
        y: 16
      });
      gsap.set(".pd-link", {
        y: 12
      });
      gsap.set(".pd-aurora", {
        scale: 0.9
      });
      const tl = gsap.timeline({
        defaults: {
          ease: "power3.out",
          duration: 0.72
        }
      });
      tl.to(".pd-aurora", {
        opacity: 0.08,
        scale: 1,
        duration: 1.4
      }, 0).to(".pd-eyebrow", {
        opacity: 1,
        y: 0
      }, 0.1).to(".pd-heading", {
        opacity: 1,
        y: 0
      }, 0.2).to(".pd-sub", {
        opacity: 1,
        y: 0
      }, 0.3).to(".pd-link", {
        opacity: 1,
        y: 0
      }, 0.4);
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".pd-eyebrow", ".pd-heading", ".pd-sub", ".pd-link"], {
        opacity: 1,
        y: 0
      });
      gsap.set(".pd-aurora", {
        opacity: 0.08,
        scale: 1
      });
    });
  }, {
    scope: container
  });
  return;
}